import Menus from "../Menus";

const HelpTopicModification = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Vos inscriptions", link: '/topics/inscription'},
    { label: 'Modifications', link: '/topics/inscription/modification'},
  ]
  
  const multiMenus = [
    {title: null, filter: 'HelpTopicModification'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicModification